import { type ReactNode, useEffect, useState } from 'react';
import { Sidebar, type MenuItem } from './Sidebar';
import { Header } from './Header';
import { MainContent } from './MainContent';
import { useUIStore } from '../../stores/ui.store';
import { useThemeStore } from '../../stores/theme.store';

export interface ShellProps {
  children: ReactNode;
  menuConfig: MenuItem[];
}

const BREAKPOINT_MD = 768;

export function Shell({ children, menuConfig }: ShellProps) {
  const { sidebarCollapsed } = useUIStore();
  const { mode } = useThemeStore();
  const isDark = mode === 'dark';

  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < BREAKPOINT_MD
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < BREAKPOINT_MD);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const marginLeft = isMobile ? 0 : sidebarCollapsed ? 68 : 250;

  return (
    <div
      className={`flex h-screen overflow-hidden ${isDark ? 'bg-neutral-950' : 'bg-white'}`}
      style={!isDark ? { backgroundColor: '#fffdfd' } : undefined}
    >
      <Sidebar menuConfig={menuConfig} />

      <div
        className="flex flex-col flex-1 min-h-0 min-w-0 transition-all duration-200"
        style={{ marginLeft }}
      >
        <Header />
        <MainContent>{children}</MainContent>
      </div>
    </div>
  );
}
